import { app } from '../../../app';
import { Controller } from './st-select-all.controller';

app.component('stSelectAll', {
    bindings: {
        items: '<',
        itemSelectable: '<'
    },
    controller: Controller,
    templateUrl: require('./st-select-all.html')
});



// WEBPACK FOOTER //
// ./src/portal/components/smart-table/select/st-select-all.component.js